import React from "react";
import { TextField } from "@mui/material";
import { useCurrency } from "helpers/currencyHelpers/useCurrency";
import { defaultCurrency } from "helpers/currencyHelpers/defaultCurrency";
import { NumericFormat } from "react-number-format";
interface IFormattedNumberFieldProps {
  value: number | null;
  setValue: (newValue: number | null) => void;
  label?: string;
  placeholder?: string;
  showLabel?: boolean;
  labelledById?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  allowDecimal?: boolean;
  error?: boolean;
}
export const FormattedNumberField: React.FC<IFormattedNumberFieldProps> = ({
  value,
  setValue,
  label,
  placeholder,
  showLabel,
  labelledById,
  onKeyDown,
  allowDecimal,
  error,
}) => {
  const tenantCurrency = useCurrency();
  const currentCurrency = defaultCurrency(tenantCurrency);
  return (
    <NumericFormat
      value={value}
      prefix=""
      thousandSeparator={currentCurrency.thousandsSeparator}
      decimalSeparator={currentCurrency.decimalMark}
      decimalScale={allowDecimal ? currentCurrency?.decimalPlaces : 0}
      customInput={TextField}
      InputLabelProps={{
        shrink: true,
      }}
      onValueChange={(value) => {
        setValue(
          typeof value.floatValue === "number" ? value.floatValue : null,
        );
      }}
      variant="outlined"
      size="small"
      fullWidth
      error={error}
      label={showLabel && label}
      placeholder={placeholder}
      aria-labelledby={labelledById}
      onKeyDown={onKeyDown}
    />
  );
};
